export default {
  INDEX: "/",
  CREATE: "/create",
  PROCESSING: "/processing/:id",
  RESULT: "/result/:hash",
};
